import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 3fr 4fr 6fr 6fr 2fr 1fr',
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    marginBottom: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 3fr 1fr'
    }
  }
}))
export default useStyles
